import {t} from 'i18next';
import {Column, DataTable, Steps} from 'primereact';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import SettingService from '../../services/SettingService';
import UserPayroll from './UserPayroll';
import {Panel} from 'primereact/panel';
import PayrollService from '../../services/PayrollService';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import InputNumberComponent from '../../components/inputs/InputNumberComponent';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';
import CurrencyUtils from '../../utils/CurrencyUtils';
import YesNoDialog from '../../components/YesNoDialog';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
class UserPayrollContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new PayrollService());
        this.state = {
            viewMode: props.viewMode,
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            globalLocale: props.locale,
            supportedLocales: [],
            element: {},
            showConfirmReject: false,
            showConfirmApprove: false,
            showConfirmForce: false,
            items: [
                {
                    icon: 'pi pi-list',
                    status: 'INITIATED',
                    label: t('PayrollStatus.INITIATED'),
                    template: (item) => this.itemRenderer(item, 0),
                },
                {
                    icon: 'pi pi-hourglass',
                    status: 'IN_PROGRESS',
                    label: t('PayrollStatus.IN_PROGRESS'),
                    template: (item) => this.itemRenderer(item, 1),
                },
                {
                    icon: 'pi pi-check',
                    status: 'GENERATED',
                    label: t('PayrollStatus.GENERATED'),
                    template: (item) => this.itemRenderer(item, 2),
                },
                {
                    icon: 'pi pi-verified',
                    status: 'APPROVED',
                    label: t('PayrollStatus.APPROVED'),
                    template: (item) => this.itemRenderer(item, 3),
                },
            ],
            activeIndex: 0,
        };
        this.settingService = new SettingService();
        this.editorRef = React.createRef();
    }

    itemRenderer(item, itemIndex) {
        return (
            <span>
                <a href='#' class='p-menuitem-link' role='presentation' tabindex=''>
                    <span class='p-steps-number'>
                        <i className={`${item.icon} text-xl`} />
                    </span>
                    <span class='p-steps-title'>{item.label}</span>
                </a>
            </span>
        );
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareElementBeforeRequest(element) {}
    updateElement(data) {
        this.setState(
            {
                element: UserPayroll.copy(this.state.element, data, this.state.globalLocale),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    initAfterSetElement() {
        this.unblockUi();
        if (this.state.element.status == 'REJECTED') {
            this.state.items.pop();
            this.state.items.push({
                icon: 'pi pi-times-circle',
                status: 'REJECTED',
                label: t('PayrollStatus.REJECTED'),
                template: (item) => this.itemRenderer(item, 3),
            });
        }
        let index = this.state.items.findIndex((item) => item.status === this.state.element.status);
        this.setState({activeIndex: index});
    }

    setElement() {
        const {elementId, locale} = this.state;
        this.service
            .get(elementId, locale)
            .then((data) => {
                this.setState({loading: false, locale}, () => this.updateElement(data));
            })
            .catch((err) => {
                this.handleGetDetailsError(err);
            });
    }

    initBeforeSetElement() {}

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            // {
            //     customRenderFunction: this.renderlocaleuages,
            //     rendered: true,
            //     className: 'float-left',
            // },
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }

    prepareFooterItems() {
        const {detailUrl, editUrl, locale} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const detailHref = `${detailUrl}/${this.props.elementId}/${locale}`;
        const editHref = `${editUrl}/${this.props.elementId}/${locale}`;
        return [
            {
                label: t('global.reject'),
                onClick: this.handleShowConfirmRejectDialog.bind(this),
                className: 'float-right',
                iconName: 'mdi-close',
                rendered: viewMode === 'VIEW' && this.state.element.status == 'GENERATED',
            },
            {
                label: t('global.approve'),
                onClick: this.handleShowConfirmApproveDialog.bind(this),
                className: 'float-right',
                iconName: 'mdi-check',
                rendered: viewMode === 'VIEW' && this.state.element.status == 'GENERATED',
            },
            {
                label: t('global.raport'),
                onClick: () => {
                    this.service.export(this.props.elementId, 'Wypłata', 'xlsx').catch(() => {
                        this.showErrorMessage(t('global.gegerate-error'));
                    });
                },
                className: 'float-right',
                iconName: 'mdi-file-document',
                rendered: this.state.element.status === 'APPROVED',
            },
        ];
    }

    handleShowConfirmRejectDialog(e) {
        e.preventDefault();
        this.setState({showConfirmReject: true});
    }

    handleShowConfirmApproveDialog(e) {
        e.preventDefault();
        this.setState({showConfirmApprove: true});
    }

    onExcludeAction(callback) {
        this.blockUi();
        this.service
            .exclude(this.state.elementId)
            .then(() => {
                callback();
                this.setElement();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.setState({showConfirmExcludeTransport: false});
            });
    }
    onIncludeAction(callback) {
        this.blockUi();
        this.service
            .include(this.state.elementId)
            .then(() => {
                callback();
                this.setElement();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.setState({showConfirmIncludeTransport: false});
            });
    }
    goBackUrl() {
        const {backUrl} = this.props;
        return backUrl;
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }

    breadCrumbItems() {
        return [
            {name: t('payroll.list.name'), url: '/user-payroll-list'},
            {name: t('payroll.details.name'), url: ``},
        ];
    }
    handleMarkerDrag(coordinates, markerIndex) {
        this.handleCoordinatesChange(coordinates);
    }

    amountTemplate(rowData) {
        return CurrencyUtils.currency(rowData.amountTotal);
    }

    amountBeforeLimit(rowData) {
        return CurrencyUtils.currency(rowData.amountBeforeLimit);
    }

    onRejectAction(callback) {
        this.blockUi();
        this.service
            .reject(this.state.elementId)
            .then(() => {
                callback();
                this.setElement();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.setState({showConfirmExcludeTransport: false});
            });
    }
    onApproveAction(callback) {
        this.blockUi();
        this.service
            .approve(this.state.elementId, false)
            .then(() => {
                callback();
                this.setElement();
            })
            .catch((err) => {
                if (err.errorCode == 'ALREADY_PAID_OUT') {
                    this.setState({showConfirmForce: true});
                } else {
                    this.showErrorMessage(err.message);
                    this.setState({showConfirmIncludeTransport: false});
                }
            });
    }

    onApproveForceAction(callback) {
        this.blockUi();
        this.service
            .approve(this.state.elementId, true)
            .then(() => {
                callback();
                this.setElement();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.setState({showConfirmIncludeTransport: false});
            });
    }

    renderDetails() {
        const {locale} = this.state;
        return (
            <React.Fragment>
                {this.state.showConfirmReject ? (
                    <YesNoDialog
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.onRejectAction(() => {
                                    this.setState({showConfirmReject: false});
                                    this.showSuccessMessage(t('payroll.details.reject.success'));
                                    this.unblockUi();
                                });
                            } else {
                                this.setState({showConfirmReject: false});
                            }
                        }}
                        visible={this.state.showConfirmReject}
                        header={t('payroll.details.reject.header')}
                        name='visible'
                        noButtonLabel={t('global.noButtonLabel')}
                        yesButtonLabel={t('global.yesButtonLabel')}
                        onHide={() => {
                            this.setState({showConfirmReject: false});
                        }}
                        yesButtonClassName='red-button'
                    >
                        {t('payroll.details.reject.message')}
                    </YesNoDialog>
                ) : null}

                {this.state.showConfirmApprove ? (
                    <YesNoDialog
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.onApproveAction(() => {
                                    this.setState({showConfirmApprove: false});
                                    this.showSuccessMessage(t('payroll.details.approve.success'));
                                    this.unblockUi();
                                });
                            } else {
                                this.setState({showConfirmApprove: false});
                            }
                        }}
                        visible={this.state.showConfirmApprove}
                        header={t('payroll.details.approve.header')}
                        name='visible'
                        noButtonLabel={t('global.noButtonLabel')}
                        yesButtonLabel={t('global.yesButtonLabel')}
                        onHide={() => {
                            this.setState({showConfirmApprove: false});
                        }}
                        yesButtonClassName='red-button'
                    >
                        {t('payroll.details.approve.message')}
                    </YesNoDialog>
                ) : null}
                {this.state.showConfirmForce ? (
                    <YesNoDialog
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.onApproveForceAction(() => {
                                    this.setState({showConfirmForce: false});
                                    this.setState({showConfirmApprove: false});
                                    this.showSuccessMessage(t('payroll.details.approve.success'));
                                    this.unblockUi();
                                });
                            } else {
                                this.setState({showConfirmForce: false});
                                this.setState({showConfirmApprove: false});
                            }
                        }}
                        visible={this.state.showConfirmForce}
                        header={t('payroll.details.approve.force_header')}
                        name='visible'
                        noButtonLabel={t('global.noButtonLabel')}
                        yesButtonLabel={t('global.yesButtonLabel')}
                        onHide={() => {
                            this.setState({showConfirmForce: false});
                        }}
                        yesButtonClassName='red-button'
                    >
                        {t('payroll.details.approve.force_message')}
                    </YesNoDialog>
                ) : null}
                <div className='row'>
                    <Steps model={this.state.items} activeIndex={this.state.activeIndex} readOnly={true} className='m-2 pt-4' />
                    <div className='col-12'>
                        <Panel header={t('payroll.details.header')} className='mt-2'>
                            <div className='row'>
                                {/* <Timeline value={events} layout="horizontal" align="top" content={(item) => item} /> */}

                                <InputTextComponent
                                    id={`${locale}-status`}
                                    name='status'
                                    label={t('payroll.details.status')}
                                    colClass='col-xl-12 col-lg-12 col-md-12 col-sm-12'
                                    value={t('PayrollStatus.' + this.state.element?.status)}
                                    validator={this.validator}
                                    viewMode={'VIEW'}
                                />
                                <InputCalendarRangeComponent
                                    key={'dates'}
                                    idFrom={'dateStart'}
                                    idTo={'dateEnd'}
                                    nameTo={'dateEnd'}
                                    nameFrom={'dateStart'}
                                    label={t('payroll.details.dateLabel')}
                                    labelTo={t('global.to')}
                                    labelFrom={t('global.from')}
                                    colClass='col-4'
                                    from={this.state.element.dateStart}
                                    to={this.state.element.dateEnd}
                                    validator={[this.validator, this.validatorDraft]}
                                    onChange={this.handleChange}
                                    viewMode={this.viewMode()}
                                    showTime
                                    showIcon
                                    placeholderFrom='dd-mm-rrrr'
                                    placeholderTo='dd-mm-rrrr'
                                    validateViewMode
                                    dateFormatMoment='DD-MM-YYYY'
                                    validatorsToType='after_or_equal_datetime'
                                />
                                <InputNumberComponent
                                    id='limit'
                                    name='limit'
                                    label={t('payroll.details.limit')}
                                    colClass='col-lg-6 col-md-6 col-sm-12'
                                    value={this.state.element?.limit}
                                    validator={this.validator}
                                    onChange={this.handleChange}
                                    viewMode='VIEW'
                                    validators='numeric'
                                    min={0}
                                    mode='currency'
                                />
                                <InputCheckboxComponent
                                    id='debitOverLimit'
                                    name='debitOverLimit'
                                    label={t('payroll.dialog.debitOverLimit')}
                                    labelOnRight
                                    value={this.state.element.debitOverLimit}
                                    validator={this.validator}
                                    validators='not_required'
                                    colClass='col-lg-4 col-md-4 col-sm-12'
                                    disabled
                                    onChange={this.handleChange}
                                    viewMode={'VIEW'}
                                />

                                <InputTextComponent
                                    id={`${locale}-createdByEmail`}
                                    name='createdByEmail'
                                    label={t('payroll.details.createdByEmail')}
                                    colClass='col-xl-3 col-lg-3 col-md-3 col-sm-6'
                                    value={this.state.element?.createdByEmail}
                                    validator={this.validator}
                                    viewMode={'VIEW'}
                                />
                            </div>
                        </Panel>
                        <div style={{height: '20px'}} />
                        <div className='row'>
                            <DataTable
                                emptyMessage={t('list.empty')}
                                value={this.state.element.payrolls}
                                sortField='userEmail'
                                removableSort
                                tableStyle={{minWidth: '50rem'}}
                                paginator
                                rows={25}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                            >
                                <Column sortable field='userEmail' header={t('user.email')}></Column>
                                <Column sortable field='firstName' header={t('user.firstName')}></Column>
                                <Column sortable field='lastName' header={t('user.lastName')}></Column>
                                <Column
                                    sortable
                                    field='amountTotal'
                                    header={t('payroll.details.amount')}
                                    body={this.amountTemplate}
                                    style={{width: '20%'}}
                                ></Column>
                                <Column
                                    sortable
                                    field='amountBeforeLimit'
                                    header={t('payroll.details.amount-before-limit')}
                                    body={this.amountBeforeLimit}
                                    style={{width: '20%'}}
                                ></Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

UserPayrollContainer.defaultProps = {
    backUrl: '/user-payroll-list',
    lazy: true,
};

UserPayrollContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
    detailUrl: PropTypes.string,
};

export default withRouter(withTranslation()(UserPayrollContainer));
